import React, { memo } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CustomDialogTitle from './subComponents/DialogTitle';
import CustomDialogSubtitle from './subComponents/DialogSubtitle';
import CustomDialogSubtitle2 from './subComponents/DialogSubtitle2';
import CustomDialogRightTag from './subComponents/DialogRightTag';
import CustomDialogRightTagSubtitle from './subComponents/DialogRightTagSubtitle';
import CustomDialogActions from './subComponents/DialogActions';
import { DialogTheme as _DialogTheme } from '../../themes/dialogTheme';
import { ThemeProvider } from "@material-ui/styles";

const CustomDialog = ({ children, onClose, open, dialogTheme = _DialogTheme, dialogTitle, dialogSubTitle, dialogSubTitle2, dialogActions, dialogRightTag, dialogRightTagSubtitle, hideTitle = false }) => {
    return (
        <ThemeProvider theme={dialogTheme}>
            <Dialog onClose={onClose} open={open}>
                {!hideTitle && (
                    <DialogTitle>
                    <div>
                        <CustomDialogTitle>{dialogTitle}</CustomDialogTitle>
                
                        {dialogSubTitle && (
                            <CustomDialogSubtitle>{dialogSubTitle}</CustomDialogSubtitle>
                        )}
                
                        {dialogSubTitle2 && (
                            <CustomDialogSubtitle2>{dialogSubTitle2}</CustomDialogSubtitle2>
                        )}
                    </div>
                
                    {(dialogRightTag || dialogRightTagSubtitle) && (
                        <div>
                            {dialogRightTag && (
                                <CustomDialogRightTag>{dialogRightTag}</CustomDialogRightTag>
                            )}
                            {dialogRightTagSubtitle && (
                                <CustomDialogRightTagSubtitle>
                                    {dialogRightTagSubtitle}
                                </CustomDialogRightTagSubtitle>
                            )}
                        </div>
                    )}
                </DialogTitle>
                
                )}

                <DialogContent>
                    {children}
                </DialogContent>
                <DialogActions>
                    <CustomDialogActions>
                        {dialogActions}
                    </CustomDialogActions>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

export default memo(CustomDialog);